import { useMutation } from "@apollo/client/react";
import {
  CreateCommunicationsDocument,
  CreateCommunicationsMutation,
  CommunicationsInsertInput,
  Communications,
} from "@/src/gql/graphql";

export const useLogCommunication = () => {
  const [mutate, result] = useMutation<CreateCommunicationsMutation>(CreateCommunicationsDocument);

  return {
    mutateAsync: async (input: CommunicationsInsertInput) => {
      const { __typename: _typename, id: _id, ...cleanInput } = input as CommunicationsInsertInput & {
        __typename?: unknown;
      };

      const { data, error } = await mutate({
        variables: { input: cleanInput },
        errorPolicy: "all",
        refetchQueries: ["GetCommunicationss"],
        awaitRefetchQueries: true,
      });

      if (error) throw new Error(`GraphQL error: ${error.message}`);
      const createdCommunication = data?.insertIntocommunicationsCollection?.records?.[0];
      if (!createdCommunication) throw new Error("Failed to create communication");
      return createdCommunication as Communications;
    },
    isPending: result.loading,
  };
};
